<template>
  <div class="ie-container" ref="myChart"></div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)

        var indicator = this.item.indicator
        var dataArr = [
          {
            value: this.item.data,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#4BFFFC',
                  // shadowColor: '#4BFFFC',
                  // shadowBlur: 10,
                },
                shadowColor: '#4BFFFC',
                shadowBlur: 10,
              },
            },
            areaStyle: {
              normal: {
                // 单项区域填充样式
                color: {
                  type: 'linear',
                  x: 0, //右
                  y: 0, //下
                  x2: 1, //左
                  y2: 1, //上
                  colorStops: [
                    {
                      offset: 0,
                      color: '#4BFFFC',
                    },
                    {
                      offset: 0.5,
                      color: 'rgba(0,0,0,0)',
                    },
                    {
                      offset: 1,
                      color: '#4BFFFC',
                    },
                  ],
                  globalCoord: false,
                },
                opacity: 1, // 区域透明度
              },
            },
          },
        ]
        var colorArr = ['#4BFFFC'] //颜色
        let option = {
          color: colorArr,
          radar: {
            // shape: 'circle',
            name: {
              textStyle: {
                color: '#fff',
                fontSize: 12,
              },
            },
            indicator: indicator,
            splitArea: {
              // 坐标轴在 grid 区域中的分隔区域，默认不显示。
              show: true,
              areaStyle: {
                // 分隔区域的样式设置。
                color: ['rgba(255,255,255,0)', 'rgba(255,255,255,0)'], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
              },
            },
            axisLine: {
              //指向外圈文本的分隔线样式
              lineStyle: {
                color: '#153269',
              },
            },
            splitLine: {
              lineStyle: {
                color: '#113865', // 分隔线颜色
                width: 1, // 分隔线线宽
              },
            },
          },
          series: [
            {
              type: 'radar',
              symbolSize: 8,
              // symbol: 'angle',
              data: dataArr,
            },
          ],
        }
        myChart.setOption(option)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .ie-container {
    height: 100%;
    width: 100%;
  }
</style>
